import React, {FC} from "react"

import {SpacingProps} from "@irati/ui/src/global/css"

import StyledHeaderLink, {StyledHeaderButton, StyledHeaderAnchor} from "../styled"

interface Props extends SpacingProps {
  containerProps?: object,
  to?: string,
  href?: string,
  app?: string,
  noMarginLeft?: boolean,
  id?: string,
  onClick?: () => void
}

const HeaderLink: FC<Props> = ({containerProps = {}, ...props}) => {
  if (props.to) {
    return <div {...containerProps}><StyledHeaderLink {...props} plain /></div>
  }
  if (props.href) {
    return <div {...containerProps}><StyledHeaderAnchor {...props} plain /></div>
  }
  return <div {...containerProps}><StyledHeaderButton {...props} /></div>
}

export default HeaderLink
